import Vue from 'vue'

import ModalMixin from '../modal_mixin'

export default (data) => {
  data.errors = data.errors || {}
  data.disabled = data.mode === 'show'

  new Vue({
    el: '#other-policy-content',
    mixins: [ModalMixin],
    data() {
      return data;
    },
    mounted() {
      if (data.disabled) {
        $(':input').prop('disabled', true);
        $('input[type="button"],button[type="button"]').prop('disabled', false);
      }
    },
    methods: {
      onChangePageOpen() {
        this.modal = $('#dialog_publish');
        this.modal.modal('show');
      },
      modalCancel() {
        this.modal = $('#dialog_publish');
        if (this.otherPolicy.open_flg) {
          this.otherPolicy.open_flg = false;
        } else {
          this.otherPolicy.open_flg = true;
        }
        this.modal.modal('hide');
      },
      modalSettings() {
        this.modal = $('#dialog_publish');
        this.modal.modal('hide');
      },
      saveContent() {
      },
    }
  })
}
